import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button, Modal, Textarea } from '@shared/widgets';

interface IForm {
  note: string;
}
const DEFAULT_VALUES = { note: '' };

interface Props {
  show: boolean;
  onClose: () => void;
  initialNote?: string;
  onSave: (note: string) => Promise<void>;
}

export const AddNoteModal = (props: Props) => {
  const { control, formState, handleSubmit, reset } = useForm<IForm>({ defaultValues: { ...DEFAULT_VALUES, note: props.initialNote || '' } });
  const { t } = useTranslation('reports');

  const closeHandler = () => {
    props.onClose();
    reset({ ...DEFAULT_VALUES, note: props.initialNote || '' });
  };
  const submitHandler = async (data: IForm) => await props.onSave(data.note);

  return (
    <Modal isOpen={props.show} onClose={closeHandler} title={t('card.transactions.modals.addNote.title')}>
      <form className='flex flex-col gap-5' noValidate onSubmit={handleSubmit(submitHandler)}>
        <Controller
          name='note'
          control={control}
          render={({ field: { value, onChange } }) => (
            <Textarea fitContent placeholder={t('card.transactions.modals.addNote.placeholders.enterMessage')} value={value} onChange={onChange} />
          )}
        />
        <Button fullWidth color='primary' type='submit' disabled={formState.isSubmitting}>
          {t('buttons.save', { ns: 'common' })}
        </Button>
      </form>
    </Modal>
  );
};
